import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from 'lib-trend-core';
import { AttendanceCopilotActionsComponent } from './attendance-panel-info/attendance-copilot/attendance-copilot-actions/attendance-copilot-actions.component';
import { AttendanceCopilotDrawerComponent } from './attendance-panel-info/attendance-copilot/attendance-copilot-drawer/attendance-copilot-drawer.component';
import { AttendanceCopilotInsightContentComponent } from './attendance-panel-info/attendance-copilot/attendance-copilot-insight-content/attendance-copilot-insight-content.component';
import { AttendanceCopilotInsightComponent } from './attendance-panel-info/attendance-copilot/attendance-copilot-insight/attendance-copilot-insight.component';
import { AttendanceCopilotSummaryComponent } from './attendance-panel-info/attendance-copilot/attendance-copilot-summary/attendance-copilot-summary.component';
import { AttendanceCopilotTabComponent } from './attendance-panel-info/attendance-copilot/attendance-copilot-tab.component';
import { CopilotThinkingIndicatorComponent } from './attendance-panel-info/attendance-copilot/copilot-thinking-indicator.component';
import { AttendanceOpportunityTabComponent } from './attendance-panel-info/attendance-opportunity/attendance-opportunity-tab.component';
import { CardRadarModule } from '../../kanban/card-radar/card-radar.module';
import { ActivityDialogsModule } from '../../task/activity-dialogs/activity-dialogs.module';
import { AttendancePanelChatComponent } from './attendance-panel-chat/attendance-panel-chat.component';
import { AiAssistantActivatorSelectorModule } from './attendance-panel-components/ai-assistant-activator-selector/ai-assistant-activator-selector.module';
import { AssignedUserModule } from './attendance-panel-components/assigned-user/assigned-user.module';
import { AttendanceContactCardModule } from './attendance-panel-components/attendance-contact-card/attendance-contact-card.module';
import { AttendanceMessageHitsModule } from './attendance-panel-components/attendance-message-hits/attendance-message-hits.module';
import { AttendanceWhisperModule } from './attendance-panel-components/attendance-whisper/attendance-whisper.module';
import { ChatHeaderModule } from './attendance-panel-components/chat-header/chat-header.module';
import { ChatModule } from './attendance-panel-components/chat/chat.module';
import { ConfirmationCloseAttendanceModule } from './attendance-panel-components/confirmation-close-attendance/confirmation-close-attendance.module';
import { ContacttModule } from './attendance-panel-components/contact/contact.module';
import { CrmAttendanceModule } from './attendance-panel-components/crm-integrations/crm-integrations.module';
import { CustomFieldAttendanceModule } from './attendance-panel-components/custom-field-attendance/custom-field-attendance.module';
import { ContactNewConversationModule } from './attendance-panel-components/new-conversation/new-conversation.module';
import { NoteAttendanceModule } from './attendance-panel-components/note-attendance/note-attendance.module';
import { SendButtonsAttendanceComponent } from './attendance-panel-components/send-buttons-attendance/send-buttons-attendance.component';
import { TagAttendanceModule } from './attendance-panel-components/tag-attendance/tag-attendance.module';
import { AttendancePanelInfoComponent } from './attendance-panel-info/attendance-panel-info.component';
import { AttendancePanelList } from './attendance-panel-list/attendance-panel-list.component';
import { AttendancePanelRoutingModule } from './attendance-panel-routing.module';
import { AttendancePanelComponent } from './attendance-panel.component';
import { Effects } from './state/effects';
import { attendanceReducers } from './state/reducers';
import { TimelineAttendanceComponent } from '../timeline-attendance/timeline-attendance.component';
import { OpportunityComponent } from './attendance-panel-components/opportunity/opportunity.component';
import { SoftphoneModule } from '../../softphone/softphone.module';

@NgModule({
  imports: [
    SharedModule,
    PickerModule,
    AttendancePanelRoutingModule,

    // components
    AssignedUserModule,
    AttendanceContactCardModule,
    AttendanceMessageHitsModule,
    AttendanceWhisperModule,
    ChatHeaderModule,
    ChatModule,
    ContacttModule,
    ContactNewConversationModule,
    NoteAttendanceModule,
    TagAttendanceModule,
    AiAssistantActivatorSelectorModule,
    // WaTemplateModule,
    CustomFieldAttendanceModule,
    CrmAttendanceModule,
    ConfirmationCloseAttendanceModule,
    SoftphoneModule,
    CardRadarModule,
    // The conclusion and postpone dialogs of the opportunity tab (E4 RF-17, RF-24).
    ActivityDialogsModule,

    // ngrx
    EffectsModule.forFeature([Effects]),
    StoreModule.forFeature('attendanceState', attendanceReducers)
  ],
  declarations: [
    AttendancePanelComponent,
    AttendancePanelList,
    AttendancePanelChatComponent,
    AttendancePanelInfoComponent,
    SendButtonsAttendanceComponent,
    TimelineAttendanceComponent,
    OpportunityComponent,
    AttendanceCopilotTabComponent,
    AttendanceCopilotSummaryComponent,
    AttendanceCopilotDrawerComponent,
    AttendanceCopilotInsightComponent,
    AttendanceCopilotInsightContentComponent,
    AttendanceCopilotActionsComponent,
    CopilotThinkingIndicatorComponent,
    AttendanceOpportunityTabComponent,
  ],
  exports: [
    AttendancePanelComponent,
    AttendancePanelList,
    AttendancePanelChatComponent,
    AttendancePanelInfoComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AttendancePanelModule { }
